import { SpaceBetween } from "@cloudscape-design/components-themed";
import Table from "../components/merchants/Table";
import SearchBar from "../components/merchants/SearchBar";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { stringToBoolean } from "../components/default-constants";
import { useAppDispatch } from "../app/hook";
import {
  INITIAL_SEARCH_CRITERIA,
  setSearchCriteria,
} from "../features/slices/merchant-list";

const Merchants = () => {
  // 権限制御
  const authenticated = useAuthenticationHook(PERMISSIONS.APPLY_COMPANY_LIST);
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(search);
  const isBackFromDetail = stringToBoolean(query.get("isBackFromDetail"));
  const [isSkipSearch, setIsSkipSearch] = useState(true);

  useEffect(() => {
    if (isBackFromDetail) {
      setIsSkipSearch(false);
    } else {
      dispatch(setSearchCriteria(INITIAL_SEARCH_CRITERIA));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <SpaceBetween size="l">
      {authenticated && (
        <>
          <SearchBar setIsSkipSearch={setIsSkipSearch} />
          <Table
            isBackFromDetail={isBackFromDetail}
            isSkipSearch={isSkipSearch}
          />
        </>
      )}
    </SpaceBetween>
  );
};

export default Merchants;
